import { gql } from '@apollo/client'

export const CREATE_TAX_INPUT = gql`
  mutation CreateTaxInput(
    $language: String!
    $caIncome: Float!
    $filingStatus: String!
    $qualifyingChildren: String!
    $qualifyingChildrenUnder17: String!
    $totalIncome: Float!
    $ageOnDec31: Int!
    $usCitizenSsn: Boolean
    $taxesWithItin: Boolean
    $livedInUs6Months: Boolean
    $livedInCa6Months: Boolean
    $notDependent: Boolean
    $noInvestmentIncomeOver11k: Boolean
    $hasChildUnder6: Boolean
    $fosterCareAfter13: Boolean
    $spouseSsn: Boolean
    $source: String
  ) {
    createTaxInput(
      language: $language
      caIncome: $caIncome
      filingStatus: $filingStatus
      qualifyingChildren: $qualifyingChildren
      qualifyingChildrenUnder17: $qualifyingChildrenUnder17
      totalIncome: $totalIncome
      ageOnDec31: $ageOnDec31
      usCitizenSsn: $usCitizenSsn
      taxesWithItin: $taxesWithItin
      livedInUs6Months: $livedInUs6Months
      livedInCa6Months: $livedInCa6Months
      notDependent: $notDependent
      noInvestmentIncomeOver11k: $noInvestmentIncomeOver11k
      hasChildUnder6: $hasChildUnder6
      fosterCareAfter13: $fosterCareAfter13
      spouseSsn: $spouseSsn
      source: $source
    ) {
      success
    }
  }
`
